import actionTypes from './actionTypes';

const INITIAL_STATE = {
  loading: false,
  failed: false,
  error: false,
  firstName: '',
  lastName: '',
  message: null,

  meInfoLoading: false,
  meInfoFailed: false,
  meInfoError: false,
  meInfoMessage: null,
  meInfo: {},

  forgetPasswordLoading: false,
  forgetPasswordFailed: false,
  forgetPasswordError: false,
  forgetPasswordMessage: null,
  forgetPassword: null,

  checkVerificationCodeLoading: false,
  checkVerificationCodeFailed: false,
  checkVerificationCodeError: false,
  checkVerificationCodeMessage: null,
  checkVerificationCode: null,

  setNewPasswordLoading: false,
  setNewPasswordFailed: false,
  setNewPasswordError: false,
  setNewPasswordMessage: null,
  setNewPassword: {},
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.LOGIN_LOADING:
      return {
        ...state,
        loading: true,
        failed: false,
        error: false,
        message: null
      };
    case actionTypes.LOGIN_SUCCESS:
      const { firstName, lastName } = action.payload;
      return {
        ...state,
        loading: false,
        failed: false,
        error: false,
        message: null,
        firstName,
        lastName
      };
    case actionTypes.LOGIN_FAILURE:
      const { message } = action.payload;
      return {
        ...state,
        loading: false,
        failed: true,
        error: false,
        message
      };
    case actionTypes.LOGIN_REJECT:
      return {
        ...state,
        loading: false,
        failed: false,
        error: true,
        message: null
      };

    case actionTypes.GET_ME_INFO_LOADING: {
      return {
        ...state,
        meInfoLoading: true,
        meInfoFailed: false,
        meInfoError: false,
        meInfoMessage: null,
        meInfo: {}
      };
    }
    case actionTypes.GET_ME_INFO_SUCCESS: {
      return {
        ...state,
        meInfoLoading: false,
        meInfoFailed: false,
        meInfoError: false,
        meInfoMessage: null,
        meInfo: { ...action.payload }
      };
    }
    case actionTypes.GET_ME_INFO_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        meInfoLoading: false,
        meInfoFailed: true,
        meInfoError: false,
        meInfoMessage: message,
        meInfo: {}
      };
    }
    case actionTypes.GET_ME_INFO_REJECT: {
      const { message } = action.payload;

      return {
        ...state,
        meInfoLoading: false,
        meInfoFailed: false,
        meInfoError: false,
        meInfoMessage: message,
        meInfo: {}
      };
    }


    case actionTypes.FORGET_PASSWORD_LOADING: {
      return {
        ...state,
        forgetPasswordLoading: true,
        forgetPasswordFailed: false,
        forgetPasswordError: false,
        forgetPasswordMessage: null,
        forgetPassword: null
      };
    }
    case actionTypes.FORGET_PASSWORD_SUCCESS: {
      return {
        ...state,
        forgetPasswordLoading: false,
        forgetPasswordFailed: false,
        forgetPasswordError: false,
        forgetPasswordMessage: null,
        forgetPassword: action.payload.timer
      };
    }
    case actionTypes.FORGET_PASSWORD_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        forgetPasswordLoading: false,
        forgetPasswordFailed: true,
        forgetPasswordError: false,
        forgetPasswordMessage: message,
        forgetPassword: null
      };
    }
    case actionTypes.FORGET_PASSWORD_REJECT: {
      const { message } = action.payload;

      return {
        ...state,
        forgetPasswordLoading: false,
        forgetPasswordFailed: false,
        forgetPasswordError: false,
        forgetPasswordMessage: message,
        forgetPassword: null
      };
    }


    case actionTypes.CHECK_VERIFICATION_CODE_LOADING: {
      return {
        ...state,
        checkVerificationCodeLoading: true,
        checkVerificationCodeFailed: false,
        checkVerificationCodeError: false,
        checkVerificationCodeMessage: null,
        checkVerificationCode: null
      };
    }
    case actionTypes.CHECK_VERIFICATION_CODE_SUCCESS: {
      return {
        ...state,
        checkVerificationCodeLoading: false,
        checkVerificationCodeFailed: false,
        checkVerificationCodeError: false,
        checkVerificationCodeMessage: null,
        checkVerificationCode: action.payload.resetPassToken
      };
    }
    case actionTypes.CHECK_VERIFICATION_CODE_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        checkVerificationCodeLoading: false,
        checkVerificationCodeFailed: true,
        checkVerificationCodeError: false,
        checkVerificationCodeMessage: message,
        checkVerificationCode: null
      };
    }
    case actionTypes.CHECK_VERIFICATION_CODE_REJECT: {
      const { message } = action.payload;

      return {
        ...state,
        checkVerificationCodeLoading: false,
        checkVerificationCodeFailed: false,
        checkVerificationCodeError: false,
        checkVerificationCodeMessage: message,
        checkVerificationCode: null
      };
    }

    case actionTypes.SET_NEW_PASSWORD_LOADING: {
      return {
        ...state,
        setNewPasswordLoading: true,
        setNewPasswordFailed: false,
        setNewPasswordError: false,
        setNewPasswordMessage: null,
        setNewPassword: {}
      };
    }
    case actionTypes.SET_NEW_PASSWORD_SUCCESS: {
      return {
        ...state,
        setNewPasswordLoading: false,
        setNewPasswordFailed: false,
        setNewPasswordError: false,
        setNewPasswordMessage: null,
        setNewPassword: { ...action.payload }
      };
    }
    case actionTypes.SET_NEW_PASSWORD_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        setNewPasswordLoading: false,
        setNewPasswordFailed: true,
        setNewPasswordError: false,
        setNewPasswordMessage: message,
        setNewPassword: {}
      };
    }
    case actionTypes.SET_NEW_PASSWORD_REJECT: {
      const { message } = action.payload;

      return {
        ...state,
        setNewPasswordLoading: false,
        setNewPasswordFailed: false,
        setNewPasswordError: false,
        setNewPasswordMessage: message,
        setNewPassword: {}
      };
    }

    default:
      return state;
  }
};
